/**
 * CSS generator for activity data step detail form (Figma 11320-26855 / 11340-26997).
 */
import type { CssGeneratorContext } from '../css-generator.model';

export const styles = ({ dt }: CssGeneratorContext) => `.activity-data-detail-form {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  width: 100%;
  box-sizing: border-box;
  padding: ${dt('appActivityDataDetailForm.root.padding')};
  background: ${dt('appActivityDataDetailForm.root.background')};
  border-radius: ${dt('appActivityDataDetailForm.root.borderRadius')};
  overflow: hidden;
}

.activity-data-market-checkboxes {
  display: flex;
  flex-direction: column;
  gap: ${dt('appActivityDataDetailForm.marketCheckboxesGap')};
}

.activity-data-market-row {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) minmax(8rem, 12rem) auto;
  align-items: center;
  gap: ${dt('appActivityDataDetailForm.capacityRow.gap')};
  padding-top: ${dt('appActivityDataDetailForm.capacityRow.paddingY')};
  padding-bottom: ${dt('appActivityDataDetailForm.capacityRow.paddingY')};
  border-bottom: 1px solid ${dt('appActivityDataDetailForm.capacityRow.borderColor')};
}

.activity-data-market-question {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.activity-data-market-question-label {
  font-size: ${dt('appActivityDataDetailForm.infoRow.labelFontSize')};
  line-height: ${dt('appActivityDataDetailForm.infoRow.labelLineHeight')};
  color: ${dt('appActivityDataDetailForm.infoRow.labelColor')};
}

.activity-data-market-countries {
  display: block;
  text-align: justify;
  font-size: ${dt('appActivityDataDetailForm.infoRow.subLabelFontSize')};
  line-height: ${dt('appActivityDataDetailForm.infoRow.subLabelLineHeight')};
  color: ${dt('appActivityDataDetailForm.infoRow.labelColor')};
}

.activity-data-selection-label {
  display: block;
  text-align: center;
  font-size: ${dt('appActivityDataDetailForm.selectionStateLabel.fontSize')};
  line-height: ${dt('appActivityDataDetailForm.selectionStateLabel.lineHeight')};
  font-weight: ${dt('appActivityDataDetailForm.selectionStateLabel.fontWeight')};
  color: ${dt('appActivityDataDetailForm.selectionStateLabel.color')};
}

.activity-data-selection-label--empty {
  visibility: hidden;
}

.activity-data-market-row .activity-data-tri-state-control {
  justify-self: end;
}

.activity-data-capacity-row {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto auto;
  align-items: center;
  gap: ${dt('appActivityDataDetailForm.capacityRow.gap')};
  padding-top: ${dt('appActivityDataDetailForm.capacityRow.paddingY')};
  padding-bottom: ${dt('appActivityDataDetailForm.capacityRow.paddingY')};
  border-bottom: 1px solid ${dt('appActivityDataDetailForm.capacityRow.borderColor')};
}

.activity-data-capacity-row .activity-data-capacity-input-block {
  justify-self: end;
  width: fit-content;
  max-width: 100%;
}

.activity-data-capacity-row .activity-data-capacity-input-block .p-inputnumber {
  display: inline-flex;
  width: auto;
  max-width: 100%;
}

.activity-data-capacity-row .activity-data-capacity-input-block .p-inputnumber .p-inputnumber-button {
  flex: 0 0 auto;
  flex-shrink: 0;
}

.activity-data-capacity-row .activity-data-capacity-input-block .p-inputnumber .p-inputnumber-input,
.activity-data-capacity-row .activity-data-capacity-input-block .p-inputnumber .p-inputtext {
  flex: 0 0 ${dt('appActivityDataDetailForm.capacityRow.inputFieldWidth')};
  width: ${dt('appActivityDataDetailForm.capacityRow.inputFieldWidth')};
  min-width: ${dt('appActivityDataDetailForm.capacityRow.inputFieldWidth')};
  max-width: ${dt('appActivityDataDetailForm.capacityRow.inputFieldWidth')};
  box-sizing: border-box;
  padding-left: ${dt('appActivityDataDetailForm.capacityRow.inputPaddingX')} !important;
  padding-right: ${dt('appActivityDataDetailForm.capacityRow.inputPaddingX')} !important;
  font-size: ${dt('appActivityDataDetailForm.capacityRow.inputFontSize')} !important;
  line-height: ${dt('appActivityDataDetailForm.capacityRow.inputLineHeight')} !important;
  font-variant-numeric: tabular-nums;
  text-align: left;
}

.activity-data-capacity-row > .activity-data-tri-state-btn {
  justify-self: end;
}

.activity-data-capacity-number {
  min-width: 2.5rem;
  height: ${dt('appActivityDataDetailForm.capacityRow.numberCell.minHeight')};
  min-height: ${dt('appActivityDataDetailForm.capacityRow.numberCell.minHeight')};
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${dt('appActivityDataDetailForm.capacityRow.numberCell.background')};
  padding: ${dt('appActivityDataDetailForm.capacityRow.numberCell.padding')};
  border-radius: ${dt('appActivityDataDetailForm.capacityRow.numberCell.borderRadius')};
  font-size: ${dt('appActivityDataDetailForm.capacityRow.numberCell.fontSize')};
  font-weight: ${dt('appActivityDataDetailForm.capacityRow.numberCell.fontWeight')};
  color: ${dt('appActivityDataDetailForm.capacityRow.numberCell.color')};
  flex-shrink: 0;
}

.activity-data-capacity-row .activity-data-capacity-label {
  font-size: ${dt('appActivityDataDetailForm.infoRow.labelFontSize')};
  line-height: ${dt('appActivityDataDetailForm.infoRow.labelLineHeight')};
  color: ${dt('appActivityDataDetailForm.infoRow.labelColor')};
  min-width: 0;
}

.activity-data-capacity-row--disabled .activity-data-capacity-number {
  background: ${dt('appActivityDataDetailForm.capacityRow.disabled.numberCell.background')};
  color: ${dt('appActivityDataDetailForm.capacityRow.disabled.numberCell.color')};
}

.activity-data-capacity-row--disabled .activity-data-capacity-label {
  color: ${dt('appActivityDataDetailForm.capacityRow.disabled.labelColor')};
}

.activity-data-capacity-row--disabled .p-inputnumber .p-inputtext {
  border: 1px solid ${dt('appActivityDataDetailForm.capacityRow.disabled.inputBorderColor')};
  color: ${dt('appActivityDataDetailForm.capacityRow.disabled.inputTextColor')};
  background: ${dt('form.field.background')};
}

.activity-data-capacity-row--disabled .p-inputnumber .p-inputnumber-increment-button,
.activity-data-capacity-row--disabled .p-inputnumber .p-inputnumber-decrement-button {
  border: 1px solid ${dt('appActivityDataDetailForm.capacityRow.disabled.inputBorderColor')};
  color: ${dt('appActivityDataDetailForm.capacityRow.disabled.buttonIconColor')};
  background: ${dt('form.field.background')};
}

.activity-data-risk-row {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) minmax(8rem, 12rem) auto;
  align-items: center;
  gap: ${dt('appActivityDataDetailForm.capacityRow.gap')};
  padding-top: ${dt('appActivityDataDetailForm.capacityRow.paddingY')};
  padding-bottom: ${dt('appActivityDataDetailForm.capacityRow.paddingY')};
  border-bottom: 1px solid ${dt('appActivityDataDetailForm.capacityRow.borderColor')};
}

.activity-data-risk-row .activity-data-risk-question {
  font-size: ${dt('appActivityDataDetailForm.infoRow.labelFontSize')};
  line-height: ${dt('appActivityDataDetailForm.infoRow.labelLineHeight')};
  color: ${dt('appActivityDataDetailForm.infoRow.labelColor')};
  min-width: 0;
}

.activity-data-risk-row .activity-data-tri-state-control {
  justify-self: end;
}

.activity-data-indicator-row--readonly {
  grid-template-columns: auto minmax(0, 1fr) minmax(8rem, 12rem);
}

.activity-data-indicator-row--readonly .activity-data-selection-label {
  text-align: center;
}

.activity-data-detail-form .activity-data-market-checkboxes label {
  font-size: ${dt('appActivityDataDetailForm.marketCheckboxDisabledLabel.fontSize')};
  line-height: ${dt('appActivityDataDetailForm.marketCheckboxDisabledLabel.lineHeight')};
  color: ${dt('surface.950')};
}

.activity-data-save-button .p-button {
  background: ${dt('appActivityDataDetailForm.saveButton.background')};
  color: ${dt('appActivityDataDetailForm.saveButton.color')};
  border-color: ${dt('appActivityDataDetailForm.saveButton.background')};
}

.activity-data-save-button .p-button:hover:not(:disabled) {
  background: ${dt('primary.hover.color')};
  border-color: ${dt('primary.hover.color')};
  color: ${dt('appActivityDataDetailForm.saveButton.color')};
}

.activity-data-detail-form app-accordion-section {
  display: block;
  width: 100%;
}

.activity-data-detail-form app-accordion-section .p-accordion {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.activity-data-detail-form app-accordion-section .p-accordionpanel > .p-accordionheader,
.activity-data-detail-form app-accordion-section .p-accordionpanel.p-accordionpanel-active > .p-accordionheader {
  background: ${dt('appActivityDataDetailForm.detailTitle.background')} !important;
  border: none !important;
  border-radius: 0 !important;
  box-shadow: none !important;
}

.activity-data-detail-form app-accordion-section .p-accordionpanel > .p-accordionheader:hover,
.activity-data-detail-form app-accordion-section .p-accordionpanel.p-accordionpanel-active > .p-accordionheader:hover,
.activity-data-detail-form app-accordion-section .p-accordionpanel > .p-accordionheader:focus-within,
.activity-data-detail-form app-accordion-section .p-accordionpanel.p-accordionpanel-active > .p-accordionheader:focus-within {
  background: ${dt('appActivityDataDetailForm.detailTitle.background')} !important;
}

.activity-data-detail-form app-accordion-section .p-accordionheader-link {
  background: transparent !important;
  color: ${dt('appActivityDataDetailForm.detailTitle.color')} !important;
  font-family: ${dt('appActivityDataDetailForm.detailTitle.fontFamily')} !important;
  font-size: ${dt('appActivityDataDetailForm.detailTitle.fontSize')} !important;
  font-weight: ${dt('appActivityDataDetailForm.detailTitle.fontWeight')} !important;
  line-height: ${dt('appActivityDataDetailForm.detailTitle.lineHeight')} !important;
  min-height: ${dt('appActivityDataDetailForm.detailTitle.minHeight')} !important;
  padding: ${dt('appActivityDataDetailForm.detailTitle.padding')} !important;
  border: none !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  cursor: default !important;
}

.activity-data-detail-form app-accordion-section .p-accordionheader-link:hover,
.activity-data-detail-form app-accordion-section .p-accordionheader-link:focus-visible {
  background: transparent !important;
  color: ${dt('appActivityDataDetailForm.detailTitle.color')} !important;
}

.activity-data-detail-form app-accordion-section .accordion-section-header-title {
  color: inherit !important;
  font-family: inherit !important;
  font-size: inherit !important;
  font-weight: inherit !important;
  line-height: inherit !important;
}

.activity-data-detail-form app-accordion-section .p-accordionheader-toggle-icon {
  display: none !important;
}

.activity-data-detail-form app-accordion-section .p-accordioncontent {
  border: none !important;
  background: ${dt('appActivityDataDetailForm.root.background')} !important;
}

.activity-data-detail-form app-accordion-section .p-accordioncontent-content {
  padding: 0 !important;
}

.activity-data-detail-form app-accordion-section .accordion-section-content {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: ${dt('appActivityDataDetailForm.content.blockGap')};
  padding: ${dt('appActivityDataDetailForm.content.padding')};
  width: 100%;
  box-sizing: border-box;
}

.activity-data-detail-form .activity-data-detail-sections {
  display: flex;
  flex-direction: column;
  gap: ${dt('appActivityDataDetailForm.content.sectionsGap')};
  width: 100%;
}

.activity-data-detail-form app-section {
  gap: ${dt('appActivityDataDetailForm.content.sectionsGap')};
  width: 100%;
}

.activity-data-detail-form app-section .header {
  min-height: ${dt('appActivityDataDetailForm.sectionHeader.minHeight')};
  padding: ${dt('appActivityDataDetailForm.sectionHeader.padding')};
  display: flex;
  align-items: center;
  box-sizing: border-box;
  background: ${dt('appActivityDataDetailForm.sectionHeader.background')} !important;
}

.activity-data-detail-form app-section .header span {
  font-size: ${dt('appActivityDataDetailForm.sectionHeader.fontSize')} !important;
  line-height: ${dt('appActivityDataDetailForm.sectionHeader.lineHeight')} !important;
  font-weight: ${dt('appActivityDataDetailForm.sectionHeader.fontWeight')} !important;
  color: ${dt('appActivityDataDetailForm.sectionHeader.color')} !important;
}

.activity-data-other-info {
  display: flex;
  flex-direction: column;
  gap: ${dt('appActivityDataDetailForm.content.blockGap')};
  width: 100%;
  min-width: 0;
  max-width: 100%;
}

.activity-data-other-info-question-row {
  display: flex;
  align-items: center;
  gap: ${dt('appActivityDataDetailForm.otherInfo.questionRow.gap')};
  padding-top: ${dt('appActivityDataDetailForm.otherInfo.questionRow.paddingY')};
  padding-bottom: ${dt('appActivityDataDetailForm.otherInfo.questionRow.paddingY')};
  border-bottom: 1px solid ${dt('appActivityDataDetailForm.otherInfo.questionRow.borderColor')};
}

.activity-data-other-info-question-label {
  font-size: ${dt('appActivityDataDetailForm.infoRow.labelFontSize')};
  line-height: ${dt('appActivityDataDetailForm.infoRow.labelLineHeight')};
  color: ${dt('appActivityDataDetailForm.infoRow.labelColor')};
  white-space: nowrap;
}

.activity-data-other-info-multiselect {
  width: 100%;
  max-width: ${dt('appActivityDataDetailForm.otherInfo.multiselect.maxWidth')};
  min-width: 0;
}

/* Optimus label uses nowrap — allow chips to wrap within the standard field width. */
.activity-data-other-info-multiselect .p-multiselect-label {
  white-space: normal;
}

.activity-data-other-info-multiselect .app-chip-item {
  max-width: 100%;
}

/* Body-appended overlay — class is set only by app-clsf-grouped-activity-multiselect. */
.p-multiselect-overlay.customMultiselect.activity-data-illegal-activities-panel {
  max-width: min(90vw, ${dt('appActivityDataDetailForm.otherInfo.multiselect.maxWidth')});
}

.p-multiselect-overlay.customMultiselect.activity-data-illegal-activities-panel .p-multiselect-option {
  white-space: normal !important;
}

.activity-data-other-info-readonly-block {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.activity-data-other-info-readonly-label {
  font-size: ${dt('appActivityDataDetailForm.otherInfo.readonlyLabel.fontSize')};
  line-height: ${dt('appActivityDataDetailForm.otherInfo.readonlyLabel.lineHeight')};
  font-weight: ${dt('appActivityDataDetailForm.otherInfo.readonlyLabel.fontWeight')};
  color: ${dt('appActivityDataDetailForm.otherInfo.readonlyLabel.color')};
}

.activity-data-other-info-readonly-value {
  font-size: ${dt('appActivityDataDetailForm.infoRow.labelFontSize')};
  line-height: ${dt('appActivityDataDetailForm.infoRow.labelLineHeight')};
  color: ${dt('appActivityDataDetailForm.infoRow.labelColor')};
}

`;
